import * as React from "react"

import { cn } from "../../lib/utils"

// The field box every text-like control shares (Input, DatePicker and Combobox
// triggers): 38px, radius 8, line border, gold focus ring, gold-deep invalid.
const inputClassName =
  "h-[38px] w-full min-w-0 rounded-[8px] border border-[#D4D8DE] bg-white px-3 py-1 text-base text-[#1A1A1A] transition-[border-color,box-shadow] duration-150 ease-out outline-none placeholder:text-[#8899AA] selection:bg-[color:var(--eq-navy)] selection:text-white md:text-sm " +
  "focus-visible:border-[color:var(--eq-gold)] focus-visible:ring-[3px] focus-visible:ring-[rgba(223,192,106,0.18)] " +
  "aria-invalid:border-[color:var(--eq-gold-deep)] aria-invalid:ring-[rgba(199,168,79,0.18)] " +
  "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        inputClassName,
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[#1A1A1A]",
        className
      )}
      {...props}
    />
  )
}

export { Input, inputClassName }
